import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MenuItem, SelectItem} from 'primeng/api';
import {classToClass, plainToClass} from 'class-transformer';
import {
  BreadcrumbMain,
  CommonTransformationService,
  DefaultOrg,
  PatternFor2Digits,
  PatternFor5DigitsDecimal,
  PaymentTerm,
  PaymentTermType,
  PrimeNgConfig,
  PrimeNgSupportService,
  RouteLink,
  TableColumn,
  TableFormat,
  TradingPartnerService,
  Validation
} from '@app/shared';


@Component({
  selector: 'app-payment-terms-admin',
  templateUrl: './payment-terms-admin.component.html',
  styleUrls: ['./payment-terms-admin.component.css']
})
export class PaymentTermsAdminComponent implements OnInit, AfterViewInit {

  DefaultOrg = DefaultOrg;
  patternFor2Digits = PatternFor2Digits;
  patternFor5DigitsDecimal = PatternFor5DigitsDecimal;
  PaymentTermChangeType: typeof PaymentTermChangeType = PaymentTermChangeType;
  PaymentTermType = PaymentTermType;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  breadcrumb: MenuItem[];
  paymentTerms: PaymentTerm[];
  paymentTermToEdit: PaymentTerm;
  selectedPaymentTerm: PaymentTerm;
  paymentTermChangeType: PaymentTermChangeType;
  tableColumns: TableColumn[];
  paymentTermsDialog: boolean = false;
  dialogHeader: string;
  errorMessageForSameTermName: string;
  paymentTermsTypesDropdown: SelectItem[];

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

  constructor(private dataService: TradingPartnerService, private transform: CommonTransformationService,
              private primeNgService: PrimeNgSupportService) {
  }

  ngOnInit() {
    this.buildMenus();
    this.getPaymentTerms();
  }

  ngAfterViewInit() {
    this.initTableColumns();
  }

  onClickAddPaymentTerm(): void {
    this.paymentTermChangeType = PaymentTermChangeType.Add;
    this.paymentTermToEdit = new PaymentTerm();
    this.selectedPaymentTerm = null;
    this.paymentTermsDialog = true;
    this.errorMessageForSameTermName = null;
  }

  onClickOverridePaymentTerm(paymentTerm: PaymentTerm): void {
    this.paymentTermChangeType = PaymentTermChangeType.Override;
    this.selectedPaymentTerm = paymentTerm;
    this.paymentTermToEdit = classToClass(paymentTerm);
    this.paymentTermToEdit.orgId = null;
    this.paymentTermToEdit.id = null;
    this.paymentTermsDialog = true;
    this.errorMessageForSameTermName = null;
  }

  onClickEditPaymentTerm(paymentTerm: PaymentTerm): void {
    this.paymentTermChangeType = PaymentTermChangeType.Update;
    this.selectedPaymentTerm = paymentTerm;
    this.paymentTermToEdit = classToClass(paymentTerm);
    this.paymentTermsDialog = true;
    this.errorMessageForSameTermName = null;
  }

  isDuplicateTermName(termName: string): void {
    this.errorMessageForSameTermName = null;
    const paymentTerms = this.paymentTerms.filter(terms => terms.paymentTermsName == termName && ((this.paymentTermToEdit.orgId && terms.orgId == this.paymentTermToEdit.orgId) || (!this.paymentTermToEdit.orgId)));
    if ((this.paymentTermToEdit.id && paymentTerms.length > 0 && paymentTerms[0].id != this.paymentTermToEdit.id) || (!this.paymentTermToEdit.id && paymentTerms.length > 0)) {
      this.errorMessageForSameTermName = "Term name already exists. Please enter a unique name.";
    }
  }

  saveOrUpdatePaymentTerm(paymentTerm: PaymentTerm): void {
    this.dataService.saveOrUpdatePaymentTerm(paymentTerm).subscribe(res => {
      const updatedPaymentTerm = plainToClass(PaymentTerm, res as PaymentTerm);
      if (this.selectedPaymentTerm) { // replace the selectedPaymentTerm with the updated one
        const index = this.paymentTerms.findIndex(paymentTerm => paymentTerm == this.selectedPaymentTerm);
        if (index >= 0) {
          this.paymentTerms[index] = updatedPaymentTerm;
        }
      } else {  // it was a new payment term, push it to the list
        this.paymentTerms = this.primeNgService.push(this.paymentTerms, updatedPaymentTerm);
      }
      this.paymentTermsDialog = false;
    });
  }


  private buildMenus(): void {
    this.breadcrumb = [];
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push({label: 'Payment Terms', routerLink: RouteLink.PaymentTermAdmin});
    this.paymentTermsTypesDropdown = this.transform.convertEnumToDropDown(PaymentTermType);
  }


  private getPaymentTerms(): void {
    this.dataService.getPaymentTerms().subscribe(res => {
      this.paymentTerms = plainToClass(PaymentTerm, res.list);
    });
  }


  private initTableColumns(): void {
    this.tableColumns = [
      {field: 'paymentTermType', header: 'Payment Term Type'},
      {field: 'paymentTermsName', header: 'Payment Term Name', format: TableFormat.TitleCase},
      {field: 'action', header: 'Action', template: this.actionTemplate}
    ];
  }

}

export enum PaymentTermChangeType {
  Add = "Add Payment Term", Override = "Override Payment Term", Update = "Update Payment Term"
}

